import React from 'react';
import SearchResult from '../../shared/SearchResults';

export default function CsmOpen() {
  return (
    <SearchResult
      statuses={['ACTIVE', 'NEW', 'WIP', 'ESC', 'AUI', 'RESC']}
      pageType="Opened"
    />
  );
}
